import type { Middleware } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import { configureVehicleDetails } from './config';
import { APP_NAME } from '../../../../constants';

let cachedVehicleDetailsSelectors: ReturnType<typeof configureVehicleDetails> | undefined;

// Exported for testing
export const vehicleDetailsMiddlewareClearCache = () => (cachedVehicleDetailsSelectors = undefined);

/**
 * Vehicle Details middleware for Sales Check-In
 * Handles bootstrap initialization
 */
export const vehicleDetailsMiddleware: Middleware = (_store) => (next) => (action: AnyFSA) => {
    const result = next(action);

    switch (action.type) {
        case bootstrapActionTypes.BOOTSTRAP_SUCCESS: {
            if (!cachedVehicleDetailsSelectors) {
                const selectors = configureVehicleDetails({ applicationName: APP_NAME });
                cachedVehicleDetailsSelectors = selectors;
            }
            break;
        }
    }

    return result;
};
